import { times } from 'lodash';
import React, {
	Component
} from 'react';

import styled, { keyframes } from 'styled-components';
import { B64Image } from './B64Image';


const Positioner = styled.div`
	position: absolute;
	pointer-events: none;
`

const Wrap = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
`

const sparkleAnim = keyframes`
	0% {
		transform: rotate(0deg) scale(0);
	}
	50% {
		transform: rotate(180deg) scale(1);
	}
	100% {
		transform: rotate(360deg) scale(0);
	}
`

const Sparkle = styled(B64Image)`
	transform: rotate(0deg) scale(0);
	position: absolute;
	left: ${p => p.x}%;
	top: ${p => p.y}%;

	animation-name: ${sparkleAnim};
	animation-duration: 1s;
	animation-iteration-count: infinite;
	animation-timing-function: linear;
	animation-delay: ${p => p.delay}ms;
`

export class Sparkles extends Component {

	shouldComponentUpdate(){
		return false;
	}

	random(min, max){
		return Math.floor(Math.random() * (max - min)) + min;
	}

	render(){
		return (
			<Positioner style={this.props.style}>
				<Wrap>
					{times((this.props.amount || 5), (n) => (
						<Sparkle key={n} x={this.random(0,100)} y={this.random(0,100)} delay={this.random(0, 2000)} style={{width: '10vw'}} src="/assets/navSparkle.png" />
					))}
				</Wrap>
			</Positioner>
		)
	}
}
